<div class="form-group" *ngIf="fieldType">
    <label *ngIf="!hideLabel" for="{{ fieldId }}">
        {{ fieldLabel }}&nbsp;<span *ngIf="mandatory" class="red-font">*</span>
    </label>

    <input *ngIf="type !== 'textarea'" [attr.type]="type" [placeholder]="placeholder" [id]="fieldId"
        [attr.maxlength]="maxlength" [readonly]="readonly" [value]="fieldType.value" autocomplete="off"
        (mouseenter)="showErrorOnFieldHover()" (mouseleave)="hideErrorOnFieldHoverOut()" (blur)="changeBlur($event)"
        (input)="handleInput($event)" class="form-control" [disabled]="disabled"
        [ngClass]="{ 'is-invalid': submitted && fieldType.errors }" />

    <textarea *ngIf="type === 'textarea'" [attr.maxlength]="maxlength" [placeholder]="placeholder" [id]="fieldId"
        [rows]="rows" [readonly]="readonly" [value]="fieldType.value" (mouseenter)="showErrorOnFieldHover()"
        (mouseleave)="hideErrorOnFieldHoverOut()" (blur)="changeBlur($event)" (input)="handleInput($event)"
        class="form-control" autocomplete="off"></textarea>

    <div *ngIf="fieldType.errors" class="invalid-input" [id]="errorFieldId">
        <div *ngFor="let item of fieldType.errors | keyvalue; let i = index">
            <div *ngIf="i==0" class="x-error-msg-text">
                {{errorMessages[item.key]}}
            </div>
        </div>
        <div *ngIf="fieldType.errors['custom']?.status" class="x-error-msg-text">{{fieldType.errors['custom'].message}}
        </div>
    </div>
</div>